var map = {
	"./ALL_QUESTIONS.gql": "0823",
	"./ALL_QUESTIONS_BY_ROLES.gql": "c5e5",
	"./ALL_QUESTIONS_BY_SCENARIO.gql": "0b0b",
	"./ALL_QUESTIONS_LIGHT.gql": "93a1",
	"./ALL_ROLES.gql": "c74b",
	"./ALL_ROOMS.gql": "ad26",
	"./ALL_SCENARIOS.gql": "faaf",
	"./GET_ACTIVE_ROOM.gql": "0340",
	"./GET_CONFIG.gql": "b488",
	"./GET_ENDING.gql": "a5be",
	"./GET_INFO_BOX.gql": "6e25",
	"./GET_MESSAGE_BY_PLAYER.gql": "78b2",
	"./GET_MESSAGE_BY_ROOM.gql": "385e",
	"./GET_OUTCOME_STAT.gql": "7396",
	"./GET_OUTCOME_SUMMARY.gql": "e76d",
	"./GET_PLAYER.gql": "b7d2",
	"./GET_PLAYER_BY_ROOM.gql": "896a",
	"./GET_PLAYER_FILES.gql": "bbf4",
	"./GET_PLAYER_NOTES.gql": "3cde",
	"./GET_PLAYER_REVIEW.gql": "478f",
	"./GET_POLLING_RESULT.gql": "31a2",
	"./GET_ROLE.gql": "56d7",
	"./GET_ROLE_BY_SCENARIO.gql": "deac",
	"./GET_ROOM.gql": "157f",
	"./GET_ROOM_BY_PIN.gql": "3995",
	"./LOGIN_GAME_MASTER.gql": "eae2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "085a";